<template>
  <section id="profile">
    <loading :active.sync="is_loading"></loading>
    <div id="breadcrumbs">
      <div class="bg-light py-3">
        <div class="container">
          <div class="row">
            <div class="col-md-12 mb-0">
              <div class="text-left">
                <router-link to="/">Home</router-link>
                <span class="mx-2 mb-0">/</span>
                <strong v-if="option === 'home'" class="text-black">{{
                  userData.name
                }}</strong>
                <strong v-else-if="option === 'direcciones'" class="text-black"
                  >Direcciones</strong
                >
                <strong
                  v-else-if="option === 'suscripciones'"
                  class="text-black"
                  >Suscripciones</strong
                >
                <strong v-else class="text-black">Usuario</strong>
              </div>
            </div>
          </div>
          <!-- .row -->
        </div>
        <!-- .container -->
      </div>
      <!-- .bg-light -->
    </div>
    <!-- #breadcrumbs -->
    <div class="site-section">
      <div v-if="option === 'home'" class="container">


        <!-- <div class="row justify-content-center mt-5 align-items-center">
          <div class="col-12 col-sm-6">
            <div class="product-img">
              <h2 class="text-black">
                {{ userData.name }} {{ userData.lastname }}
              </h2>
              <button
                v-if="haveExpired"
                v-on:click="changeOption('suscripciones')"
                class="btn text-light"
                style="width: 290px; height: 45px; background: green"
              >
                RENOVAR SUSCRIPCIÓN
              </button>
            </div>
          </div>
          <div v-if="is_active_magazine === true" class="col-12 pt-5">
            <h2 style="color:#f04150; font-weight: bold;">
              <img class="rewards-title pt-4" src="images/moi_rewards_encabezado2.png" alt="rewards">
            </h2>
            <div class="row">
              <div class="col-12 col-sm-4">
                <a target="blank" href="https://www.instagram.com/nicolasmieryteran/?hl=es-la">
                  <img class="w-100 rewards pt-4" src="images/moi_rewards5.jpg" alt="rewards">
                </a>
              </div>
              <div class="col-12 col-sm-4">
                <a target="blank" href="https://www.maelys.com.mx">
                  <img class="w-100 rewards pt-4" src="images/moi_rewards2.jpg" alt="rewards">
                </a>
              </div>
              <div class="col-12 col-sm-4">
                <a target="blank" href="https://www.tropicalheal.com/discount/MOI15">
                  <img class="w-100 rewards pt-4" src="images/moi_rewards_tropical.jpg" alt="rewards">
                </a>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-sm-6">
                <a target="blank" href="https://www.ticketmaster.com.mx/12-princesas-en-pugna-mexico-10-03-2023/event/3D005E48892609F9">
                  <img class="w-100 rewards pt-4" src="images/moi_rewards3.jpg" alt="rewards">
                </a>
              </div>
              <div class="col-12 col-sm-6">
                <a target="blank" href="https://www.ticketmaster.com.mx/busco-al-hombre-de-mi-vida-marido-ya-tuve-mexico-19-03-2023/event/3D005E3AA2E24426">
                  <img class="w-100 rewards pt-4" src="images/moi_rewards4.jpg" alt="rewards">
                </a>
              </div>
            </div>
          </div>
        </div> -->


        
        <div class="row my-5" style="grid-gap:30px 0;">
          <div class="col-sm-6">
            <b-card no-body class="overflow-hidden cardProfile" style="max-width: 540px">
              <b-row no-gutters>
                <b-col md="6">
                  <div class="profile-icon my-4 my-sm-2">
                    <span class="icon-map-o"></span>
                  </div>
                </b-col>
                <b-col md="6">
                  <b-card-body title="Direcciones">
                    <b-card-text>
                      Direcciones en las cuales quieres recibir tus
                      suscripciones y compras
                    </b-card-text>
                    <button
                      v-on:click="changeOption('direcciones')"
                      class="btn text-light"
                      style="width: 120px; height: 45px; background: #0f182b"
                    >
                      Ver
                    </button>
                  </b-card-body>
                </b-col>
              </b-row>
            </b-card>
          </div>
          <div class="col-sm-6">
            <b-card no-body class="overflow-hidden cardProfile" style="max-width: 540px">
              <b-row no-gutters>
                <b-col md="6">
                  <div class="profile-icon my-4 my-sm-2">
                    <span class="icon-local_library"></span>
                  </div>
                </b-col>
                <b-col md="6">
                  <b-card-body title="Suscripciones">
                    <b-card-text>
                      Ingresa al panel de suscripciones para visualizar tus
                      suscripciones activas
                    </b-card-text>
                    <button
                      v-if="subscriptions.length !== 0"
                      v-on:click="changeOption('suscripciones')"
                      class="btn text-light"
                      style="width: 120px; height: 45px; background: #0f182b" 
                    >
                      Ver
                    </button>
                    <button
                      v-else
                      class="btn text-light w-auto"
                      style="width: 120px; height: 45px; background: #0f182b" 
                    >
                    <span class="customLoader"></span>
                      Cargando...
                    </button>
                  </b-card-body>
                </b-col>
              </b-row>
            </b-card>
          </div>
          <div class="col-sm-6">
            <b-card no-body class="overflow-hidden cardProfile" style="max-width: 540px">
              <b-row no-gutters>
                <b-col md="6">
                  <div class="profile-icon my-4 my-sm-2">
                    <span class="icon-account_circle"></span>
                  </div>
                </b-col>
                <b-col md="6">
                  <b-card-body title="Usuario">
                    <b-card-text>
                      Ingresa al panel de usuario para visualizar tus datos y
                      modificarlos
                    </b-card-text>
                    <button
                      v-on:click="changeOption('usuario')"
                      class="btn text-light"
                      style="width: 120px; height: 45px; background: #0f182b"
                    >
                      Ver
                    </button>
                  </b-card-body>
                </b-col>
              </b-row>
            </b-card>
          </div>
          <div  class="col-sm-6">
            <b-card no-body class="overflow-hidden cardProfile" style="max-width: 540px">
              <b-row no-gutters>
                <b-col md="6">
                  <div class="profile-icon my-4 my-sm-2">
                    <span class="icon-library_books"></span>
                  </div>
                </b-col>
                <b-col md="6">
                  <b-card-body title="Revista Digital">
                    <b-card-text>
                      Visualiza en formato digital tú revista
                    </b-card-text>
                    <router-link
                      v-if="is_active_magazine === true"
                      :to="{
                        name: 'magazine',
                        params: { active: is_active_magazine },
                      }"
                      class="btn text-light"
                      style="width: 120px; height: 45px; background: #0f182b; display:flex; margin:auto; justify-content:center; align-items:center;">
                      Ver</router-link>

                      <router-link
                      :to="{
                        name: 'magazine',
                        params: { active: is_active_magazine },
                      }"
                      v-else
                      class="btn text-light w-auto"
                      style="width: 120px; height: 45px; background: #0f182b; display:flex; margin:auto; justify-content:center; align-items:center;">
                      <span class="customLoader"></span>
                      Cargando...</router-link>
                  </b-card-body>
                </b-col>
              </b-row>
            </b-card>
          </div>


          <!-- <div v-if="is_active_magazine" class="col-sm-6 mt-4">
            <b-card no-body class="overflow-hidden" style="max-width: 540px">
              <b-row no-gutters>
                <b-col md="6">
                  <div class="profile-icon my-4 my-sm-2">
                    <span class="icon-credit-card"></span>
                  </div>
                </b-col>
                <b-col md="6">
                  <b-card-body title="Mi Tarjeta">
                    <b-card-text>
                      Ingresa al panel de mi tarjeta y cambia los datos de tu tarjeta de pago
                    </b-card-text>
                    <button
                      v-on:click="changeOption('tarjeta')"
                      class="btn text-light"
                      style="width: 120px; height: 45px; background: #0f182b"
                    >
                      Ver
                    </button>
                  </b-card-body>
                </b-col>
              </b-row>
            </b-card>
          </div> -->


        </div>
      </div>
      <div v-else-if="option === 'direcciones'" class="container">
        <div class="d-flex justify-content-between mt-3">
          <button
            v-on:click="changeOption('home')"
            class="btn text-light"
            style="width: 120px; height: 35px; background: #0f182b"
          >
            Regresar
          </button>
          <button
            class="btn text-light"
            style="width: 220px; height: 35px; background: #0f182b"
            @click="showNewAdressForm"
          >
            Nueva Dirección
          </button>
        </div>
        <div class="empty-container" v-if="addresses.length === 0">
          <h5 class="mt-5">No tienes ninguna dirección registrada</h5>
          <b-button
            type="button"
            class="btn text-light mb-5"
            style="background: #0f182b; font-weight: bold"
            @click="showNewAdressForm"
            >REGISTRA UNA NUEVA DIRECCION</b-button
          >
        </div>
        <div v-if="showNewForm" class="new-address container my-4">
          <NewAdress @hideForm="showNewAdressForm" />
        </div>
        <div v-if="showEditForm" class="new-address container my-4">
          <EditAddress
            :address="selectedAddress"
            @hideForm="showEditFormFunction"
          />
        </div>
        <div class="row justify-content-md-center">
          <div
            class="col col-md-4"
            v-for="direccion in addresses"
            :key="direccion.id"
          >
            <Adress
              @editForm="showEditFormFunction"
              :direccionComponente="direccion"
            />
          </div>
          <!-- Direcciones -->
        </div>
      </div>
      <div v-else-if="option === 'suscripciones'" class="container">
        <div class="d-flex justify-content-start mt-3">
          <button
            v-on:click="changeOption('home')"
            class="btn text-light"
            style="width: 120px; height: 35px; background: #0f182b"
          >
            Regresar
          </button>
        </div>
        <div class="empty-container" v-if="subscriptions.length === 0">
          <h5 class="mt-5">No tienes suscripciones aún</h5>
          <b-button
            type="button"
            class="btn text-light"
            style="background: #0f182b; font-weight: bold"
            ><router-link to="/producto/1">SUSCRIBETE</router-link></b-button
          >
        </div>
        <div class="row justify-content-md-center">
          <div class="col col-md-6 col-lg-5" id="flexArea">
            <Subscription
              :suscripcionComponente="suscriptionShow"
              :renovacionesComponente="sus_renew"
              :userName="userData.name"
              :userLastName="userData.lastname"
            />
          </div>

          <!-- Direcciones -->
        </div>
      </div>
      <!-- Tarjetas -->
      <div v-else-if="option === 'tarjeta'" class="container" style="min-height:50vh;">
        <div class="row">
          <div class="col-12 py-5">
            <div class="containerCard cardPayment">
              <div class="card-face frontCard">
                <h3 class="nameCard font-weight-bold">{{nameCard}}</h3>
                <svg id="visual" viewBox="0 0 465 290" width="465" height="290" preserveAspectRatio="xMinYMin slice">
                  <path d="M800 600L786.5 580C773 560 746 520 717.5 480C689 440 659 400 654.5 360C650 320 671 280 707 240C743 200 794 160 821 120C848 80 851 40 852.5 20L854 0L900 0L900 20C900 40 900 80 900 120C900 160 900 200 900 240C900 280 900 320 900 360C900 400 900 440 900 480C900 520 900 560 900 580L900 600Z" fill="#000029"></path>
                  <path d="M674 600L675.5 580C677 560 680 520 665 480C650 440 617 400 603.5 360C590 320 596 280 618.5 240C641 200 680 160 684.5 120C689 80 659 40 644 20L629 0L855 0L853.5 20C852 40 849 80 822 120C795 160 744 200 708 240C672 280 651 320 655.5 360C660 400 690 440 718.5 480C747 520 774 560 787.5 580L801 600Z" fill="#001540"></path>
                  <path d="M440 600L461 580C482 560 524 520 518 480C512 440 458 400 419 360C380 320 356 280 330.5 240C305 200 278 160 245 120C212 80 173 40 153.5 20L134 0L630 0L645 20C660 40 690 80 685.5 120C681 160 642 200 619.5 240C597 280 591 320 604.5 360C618 400 651 440 666 480C681 520 678 560 676.5 580L675 600Z" fill="#032258"></path>
                  <path d="M152 600L155 580C158 560 164 520 165.5 480C167 440 164 400 162.5 360C161 320 161 280 156.5 240C152 200 143 160 120.5 120C98 80 62 40 44 20L26 0L135 0L154.5 20C174 40 213 80 246 120C279 160 306 200 331.5 240C357 280 381 320 420 360C459 400 513 440 519 480C525 520 483 560 462 580L441 600Z" fill="#053071"></path>
                  <path d="M0 600L0 580C0 560 0 520 0 480C0 440 0 400 0 360C0 320 0 280 0 240C0 200 0 160 0 120C0 80 0 40 0 20L0 0L27 0L45 20C63 40 99 80 121.5 120C144 160 153 200 157.5 240C162 280 162 320 163.5 360C165 400 168 440 166.5 480C165 520 159 560 156 580L153 600Z" fill="#063e8c"></path>
                </svg>
                <img loading="lazy" src="images/chip.png" alt="chip" class="chip">
                <img loading="lazy" src="images/contacless.png" alt="contacless" class="contacless">
                <div class="textCard"> 
                  <h3 class="numberCard font-weight-bold">{{numberCard | formatNumberCreditCard }}</h3>
                  <div class="dateExpiration d-flex flex-wrap flex-column align-content-start pt-5">
                    <small class="d-block">Válido hasta:</small>
                    <small class="font-weight-bold">{{monthExpiration}} / {{yearExpiration}}</small>
                  </div>
                  <div class="brandCard d-flex flex-wrap flex-row align-content-end pt-5">
                    <div class="circle1"></div>
                    <div class="circle2"></div>
                  </div>
                </div>
              </div>
              <div class="card-face backCard">
                <svg id="visual" viewBox="0 0 465 290" width="465" height="290" preserveAspectRatio="xMinYMin slice">
                  <path d="M800 600L786.5 580C773 560 746 520 717.5 480C689 440 659 400 654.5 360C650 320 671 280 707 240C743 200 794 160 821 120C848 80 851 40 852.5 20L854 0L900 0L900 20C900 40 900 80 900 120C900 160 900 200 900 240C900 280 900 320 900 360C900 400 900 440 900 480C900 520 900 560 900 580L900 600Z" fill="#000029"></path>
                  <path d="M674 600L675.5 580C677 560 680 520 665 480C650 440 617 400 603.5 360C590 320 596 280 618.5 240C641 200 680 160 684.5 120C689 80 659 40 644 20L629 0L855 0L853.5 20C852 40 849 80 822 120C795 160 744 200 708 240C672 280 651 320 655.5 360C660 400 690 440 718.5 480C747 520 774 560 787.5 580L801 600Z" fill="#001540"></path>
                  <path d="M440 600L461 580C482 560 524 520 518 480C512 440 458 400 419 360C380 320 356 280 330.5 240C305 200 278 160 245 120C212 80 173 40 153.5 20L134 0L630 0L645 20C660 40 690 80 685.5 120C681 160 642 200 619.5 240C597 280 591 320 604.5 360C618 400 651 440 666 480C681 520 678 560 676.5 580L675 600Z" fill="#032258"></path>
                  <path d="M152 600L155 580C158 560 164 520 165.5 480C167 440 164 400 162.5 360C161 320 161 280 156.5 240C152 200 143 160 120.5 120C98 80 62 40 44 20L26 0L135 0L154.5 20C174 40 213 80 246 120C279 160 306 200 331.5 240C357 280 381 320 420 360C459 400 513 440 519 480C525 520 483 560 462 580L441 600Z" fill="#053071"></path>
                  <path d="M0 600L0 580C0 560 0 520 0 480C0 440 0 400 0 360C0 320 0 280 0 240C0 200 0 160 0 120C0 80 0 40 0 20L0 0L27 0L45 20C63 40 99 80 121.5 120C144 160 153 200 157.5 240C162 280 162 320 163.5 360C165 400 168 440 166.5 480C165 520 159 560 156 580L153 600Z" fill="#063e8c"></path>
                </svg>
                <div class="magneticBand"></div>
                <div class="containerCvv">
                  <h5 class="mb-0 text-white d-inline-block pr-2">cvv: </h5>
                  <div class="cvv d-inline-block pt-1 px-2">
                    <h6 class="mb-0 d-inline text-left">{{cvv}}</h6>
                  </div>
                  <h3 class="numberCard font-weight-bold numberCardReverse mt-4">{{numberCard | formatNumberCreditCard }}</h3>
                </div>
                <div class="sealWorld mt-5">
                  <div class="seal">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M352 256C352 278.2 350.8 299.6 348.7 320H163.3C161.2 299.6 159.1 278.2 159.1 256C159.1 233.8 161.2 212.4 163.3 192H348.7C350.8 212.4 352 233.8 352 256zM503.9 192C509.2 212.5 512 233.9 512 256C512 278.1 509.2 299.5 503.9 320H380.8C382.9 299.4 384 277.1 384 256C384 234 382.9 212.6 380.8 192H503.9zM493.4 160H376.7C366.7 96.14 346.9 42.62 321.4 8.442C399.8 29.09 463.4 85.94 493.4 160zM344.3 160H167.7C173.8 123.6 183.2 91.38 194.7 65.35C205.2 41.74 216.9 24.61 228.2 13.81C239.4 3.178 248.7 0 256 0C263.3 0 272.6 3.178 283.8 13.81C295.1 24.61 306.8 41.74 317.3 65.35C328.8 91.38 338.2 123.6 344.3 160H344.3zM18.61 160C48.59 85.94 112.2 29.09 190.6 8.442C165.1 42.62 145.3 96.14 135.3 160H18.61zM131.2 192C129.1 212.6 127.1 234 127.1 256C127.1 277.1 129.1 299.4 131.2 320H8.065C2.8 299.5 0 278.1 0 256C0 233.9 2.8 212.5 8.065 192H131.2zM194.7 446.6C183.2 420.6 173.8 388.4 167.7 352H344.3C338.2 388.4 328.8 420.6 317.3 446.6C306.8 470.3 295.1 487.4 283.8 498.2C272.6 508.8 263.3 512 255.1 512C248.7 512 239.4 508.8 228.2 498.2C216.9 487.4 205.2 470.3 194.7 446.6H194.7zM190.6 503.6C112.2 482.9 48.59 426.1 18.61 352H135.3C145.3 415.9 165.1 469.4 190.6 503.6V503.6zM321.4 503.6C346.9 469.4 366.7 415.9 376.7 352H493.4C463.4 426.1 399.8 482.9 321.4 503.6V503.6z"/></svg>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M352 256C352 278.2 350.8 299.6 348.7 320H163.3C161.2 299.6 159.1 278.2 159.1 256C159.1 233.8 161.2 212.4 163.3 192H348.7C350.8 212.4 352 233.8 352 256zM503.9 192C509.2 212.5 512 233.9 512 256C512 278.1 509.2 299.5 503.9 320H380.8C382.9 299.4 384 277.1 384 256C384 234 382.9 212.6 380.8 192H503.9zM493.4 160H376.7C366.7 96.14 346.9 42.62 321.4 8.442C399.8 29.09 463.4 85.94 493.4 160zM344.3 160H167.7C173.8 123.6 183.2 91.38 194.7 65.35C205.2 41.74 216.9 24.61 228.2 13.81C239.4 3.178 248.7 0 256 0C263.3 0 272.6 3.178 283.8 13.81C295.1 24.61 306.8 41.74 317.3 65.35C328.8 91.38 338.2 123.6 344.3 160H344.3zM18.61 160C48.59 85.94 112.2 29.09 190.6 8.442C165.1 42.62 145.3 96.14 135.3 160H18.61zM131.2 192C129.1 212.6 127.1 234 127.1 256C127.1 277.1 129.1 299.4 131.2 320H8.065C2.8 299.5 0 278.1 0 256C0 233.9 2.8 212.5 8.065 192H131.2zM194.7 446.6C183.2 420.6 173.8 388.4 167.7 352H344.3C338.2 388.4 328.8 420.6 317.3 446.6C306.8 470.3 295.1 487.4 283.8 498.2C272.6 508.8 263.3 512 255.1 512C248.7 512 239.4 508.8 228.2 498.2C216.9 487.4 205.2 470.3 194.7 446.6H194.7zM190.6 503.6C112.2 482.9 48.59 426.1 18.61 352H135.3C145.3 415.9 165.1 469.4 190.6 503.6V503.6zM321.4 503.6C346.9 469.4 366.7 415.9 376.7 352H493.4C463.4 426.1 399.8 482.9 321.4 503.6V503.6z"/></svg>
                  </div>
                </div>
                <div class="line"></div>
              </div>
            </div>

            <div class="edit mt-5">
               <b-button 
               class="btn btn-light w-100 mt-3 text-white"
                style="width: 120px !important; height: 45px; background: #0f182b"
                @click="editDataCard(true)"
                >Editar</b-button>


                <form v-show="editOption" @submit="changeDataCreditCard" class="mt-5 border p-3">
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label for="nameCard">Nombre en la tarjeta</label>
                    <input type="text" class="form-control" id="nameCard" placeholder="Nombre en la tarjeta"
                    minlength="4"
                    required
                    onkeydown="return /[a-z]/i.test(event.key)"
                    v-model="nameCard">
                  </div>
                  <div class="form-group col-md-6">
                    <label for="numberCard">Numero de la tarjeta</label>
                    <input type="text" class="form-control" id="numberCard" placeholder="Numero de la tarjeta"
                      minlength="16" 
                      maxlength="16" 
                      required 
                      onkeypress="return /[0-9]/i.test(event.key)"
                      v-model="numberCard">
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-2 ">
                    <label for="cvv">Cvv</label>
                    <input type="text" class="form-control" id="cvv" placeholder="***" 
                      @focus="showBackCreditCard" 
                      @blur="hideBackCreditCard" 
                      minlength="3" 
                      maxlength="4" 
                      required 
                      onkeypress="return /[0-9]/i.test(event.key)"
                      v-model="cvv">
                  </div>
                  <div class="form-group col-md-6">
                    <label for="inputCity">Elige el mes de expiracion</label>
                      <select v-model="monthExpiration" name="openpay_card_month" id="openpay_card_month" data-openpay-card="expiration_month" class="form-control">
                          <option value="0">.: Elige el mes :.</option>
                          <option v-for="month in card_months" :value="month">{{ month }}</option>
                      </select>
                  </div>
                  <div class="form-group col-md-4">
                    <label for="inputState">Elige el año de expiracion</label>
                    <select v-model="yearExpiration" name="openpay_card_year" id="openpay_card_year" data-openpay-card="expiration_year" class="form-control">
                        <option value="0">.: Elige el año :.</option>
                        <option v-for="year in card_years" :value="year.toString().substr(-2)">{{ year }}</option>
                    </select>
                  </div>
                </div>
                <button type="submit" class="btn btn-primary mt-5 font-weight-bold">Actualizar datos</button>
              </form>
            </div>

          </div>
        </div>
      </div>

      <div v-else class="container">
        <div class="d-flex justify-content-start mt-3">
          <button
            v-on:click="changeOption('home')"
            class="btn text-light"
            style="width: 120px; height: 35px; background: #0f182b"
          >
            Regresar
          </button>
        </div>
        <div class="row justify-content-md-center">
          <User
            :userData="userData"
            @option="changeOption"
            @dataC="changeUserData"
          />
        </div>
      </div>
    </div>
    <!-- .site-section -->
  </section>
</template>

<script>
// @ is an alias to /src
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Adress from "../components/Profile/Adress.vue";
import NewAdress from "../components/NewAdress.vue";
import EditAddress from "../components/EditAddress.vue";
import Subscription from "../components/Profile/Subscription.vue";
import User from "../components/Profile/User.vue";
import Directions from "@/components/Directions.vue";
const axios = require("axios");

export default {
  name: "profile",
  data() {
    return {
      is_login: false,
      is_loading: false,
      api_url: process.env.VUE_APP_SUSCRIPTIONS_ROUTE,
      actualDate: null,
      userData: {},
      purchases: [],
      subscriptions: [],
      suscriptionShow: [],
      addresses: [],
      notSubscribed: false,
      option: "home",
      showNewForm: false,
      showEditForm: false,
      selectedAddress: {},
      haveExpired: false,
      sus_renew: [],
      is_active_magazine: false,
      editOption: false,
      card_months: [],
      card_years: [],
      nameCard: "Visa",
      numberCard:"4351  8237  2189  0104",
      cvv:"123",
      monthExpiration:"02",
      yearExpiration:"22"
    };
  },
  created() {
    if ($cookies.isKey("utoken")) {
      // Crear fecha actual del servidor
      const date = new Date();
      const dateString = new Date(
        date.getTime() - date.getTimezoneOffset() * 60000
      )
        .toISOString()
        .split("T")[0];

      this.actualDate = dateString;

      this.is_login = true;
      this.getUserData();
      //this.getPurchases();
      this.getSubscriptions();
      this.getAddresses();
    } else {
      this.$router.push("/");
    }
      this.card_months = ["01","02","03","04","05","06","07","08","09","10","11","12",];
      this.card_years = ["2022","2023","2024","2025","2026","2027","2028","2029","2030","2031","2032","2033",];
      this.loadDataCreditCard();
  },
  // watch:{
  //   option(newValue, oldvalue){
  //     if(newValue === "suscripciones"){
  //       this.getSubscriptions();
  //     }
  //   }
  // },
  components: {
    Directions,
    Adress,
    Subscription,
    NewAdress,
    EditAddress,
    Loading,
    User,
  },
  methods: {
    getUserData: function () {
      this.is_loading = true;
      axios({
        method: "GET",
        url: this.api_url + "/subscribers/" + $cookies.get("uidmmkg"),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + $cookies.get("utoken"),
        },
      })
        .then((response) => {
          this.is_loading = false;
          this.userData = response.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getPurchases: function () {
      this.is_loading = true;
      axios({
        method: "GET",
        url:
          this.api_url +
          "/subscribers/" +
          $cookies.get("uidmmkg") +
          "/purchases",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + $cookies.get("utoken"),
        },
      })
        .then((response) => {
          this.is_loading = false;
          this.purchases = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getSubscriptions: function () {
      console.log('obteniendo suscripciones:', this.api_url +
          "/subscribers/" +
          $cookies.get("uidmmkg") +
          "/subscriptions");
      axios({
        method: "GET",
        url:
          this.api_url +
          "/subscribers/" +
          $cookies.get("uidmmkg") +
          "/subscriptions",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + $cookies.get("utoken"),
        },
      })
        .then((response) => {
          this.subscriptions = response.data.data;
          console.log('show: ', this.subscriptions);
          this.suscriptionShow = this.subscriptions[0];

          this.subscriptions.forEach((sus) => {
            // Validar si existe una renovacion
            if (sus.is_renewed === 1) {
              this.sus_renew.push(sus);
            }

            //Validar si existe una suscripcion vencida
            if (sus.end_date < this.actualDate) {
              this.haveExpired = true;
            }
            console.log("suscripción vencimiento: ", sus.end_date);
            console.log("fecha actual: ", this.actualDate);
            if (sus.is_active === 1 && sus.payment.payment_status_id === 2) {
              this.is_active_magazine = true;
              console.log(this.is_active_magazine);
            }
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getAddresses: function () {
      this.is_loading = true;
      axios({
        method: "GET",
        url:
          this.api_url +
          "/subscribers/" +
          $cookies.get("uidmmkg") +
          "/addresses",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + $cookies.get("utoken"),
        },
      })
        .then((response) => {
          this.is_loading = false;
          this.addresses = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getUserSubscription: function () {
      axios({
        method: "GET",
        url:
          this.api_url +
          "subscriptions/last/{subscriber_id}" +
          $cookies.get("uidmmkg"),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + $cookies.get("utoken"),
        },
      })
        .then((response) => {
          this.userData = response.data;
        })
        .catch((error) => {
          console.error(error);
          //subscriber_id, ""code""" y message
        });
    },
    loadDataCreditCard: function(){
      console.log("obteniendo datos de tarjeta guardada");
    },
    changeOption: function (value) {
      this.option = value;
      this.showEditForm = false; //Cerrar edit form si la se da click en regresar
      this.showNewForm = false; //Cerrar new form si la se da click en regresar
    },
    changeUserData: function (value) {
      this.userData.name = value.name;
      this.userData.lastname = value.lastname;
      this.userData.surname = value.surname;
      this.userData.phone = value.phone;
      this.userData.email = value.email;
      this.userData.gender = value.gender;
    },
    showNewAdressForm: function (value) {
      this.showNewForm = true;
      this.showNewForm = value; //En cuanto se produzca el emit lo cambia el valor
    },
    showEditFormFunction: function (value, sAddress) {
      this.showEditForm = value;
      this.selectedAddress = sAddress;
    },
    showBackCreditCard: function(){
      var card = document.querySelector('.cardPayment');
      card.classList.add('is-flipped');
    },
    hideBackCreditCard: function(){
      var card = document.querySelector('.cardPayment');
      card.classList.remove('is-flipped');
    },
    editDataCard: function(){
      this.editOption = !this.editOption;
    },
    changeDataCreditCard: function(){
      console.log("se cambiaron los datos de la tarjeta");
    }
  },
  filters: {
    formatNumberCreditCard: function(string){
        var v = string.replace(/\s+/g, '').replace(/[^0-9]/gi, '')
        var matches = v.match(/\d{4,16}/g);
        var match = matches && matches[0] || ''
        var parts = []

        for (var i=0, len=match.length; i<len; i+=4) {
            parts.push(match.substring(i, i+4))
        }

        if (parts.length) {
            return parts.join('  ')
        } else {
            return string
        }
    }
  }
};
</script>

<style scoped>
.rewards{
  max-width:300px;
  margin:auto;
  display:inline-block;
}
.rewards-title{
	max-width: 500px;
	width: 100%;
}
.customLoader {
    margin-right: 10px;
    width: 25px;
    height: 25px;
    border: 4px solid #fff;
    vertical-align: bottom;
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-animation: rotation-data-v-3a99e293 1s linear infinite;
    animation: rotation-data-v-3a99e293 1s linear infinite;
}
    @keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
    } 
.empty-container {
  padding: 7% 0;
}
.new-address {
  max-width: 650px;
}

.btn a {
  text-decoration: none;
  color: #fff;
}
.profile-icon {
  font-size: 8vw;
  text-align: center;
}
.containerCard{
  width:100%;
  max-width: 465px;
  margin:auto;
  border-radius:7px;
  height:290px;
  background-image: linear-gradient(138deg, #02367d 66%, #032258);
  position:relative;
  box-shadow: 5px 3px 10px #2f2f2f;
  transform-style: preserve-3d;
  -webkit-transform-style: preserve-3d;
  transform-origin: center right;
  transition: all 1s linear;
}
.containerCard.cardPayment.is-flipped {
  transform: translateX(-100%) rotateY(-180deg) perspective(100px);
}
.card-face{
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
}
.containerCard svg{
  position:absolute;
  top:0;
  left:0;
  right: 0;
  width:100%;
  height:inherit;
  border-radius: 12px;
}
.containerCard .nameCard{
  position: absolute;
  top: 8%;
  right: 5%;
  color: #ffffff;
  z-index: 1;
}
.containerCard .chip{
  position: absolute;
  top: 20%;
  left: 5%;
  width: 60px;
}
.containerCard .contacless{
  position: absolute;
  top: 25%;
  left: 17%;
  width: 30px;
  filter: invert(1);
}
.containerCard .numberCard{
  white-space: pre;
  background: -webkit-linear-gradient(#eee, #0b0b0b);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.containerCard .numberCard.numberCardReverse{
  direction: rtl; 
  unicode-bidi: bidi-override;
  text-shadow: -3px 1px 0px white;
  color: #212121;
  opacity: 0.6;
  background: none;
  -webkit-background-clip: unset;
  -webkit-text-fill-color: unset;

}
.containerCard .textCard{
  position: absolute;
  top: 45%;
  left: 10%;
  color: #ffffff;
  width: 80%;
}
.containerCard .brandCard{
  position: absolute;
  top: 20%;
  right: 0;
  z-index: 1;
}
.containerCard .circle1{
  background-color: #f3242d;
  width: 45px;
  height: 45px;
  border-radius: 50%;
}
.containerCard .circle2{
  background-color: #e59704;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  margin-left:-15px;
  opacity:0.8;
}

.backCard{
  transform: rotateY(180deg);
  box-shadow: 0 4px 100px #ffffff;
}
.backCard .magneticBand{
  background: linear-gradient(130deg, rgba(0,0,0,1) -3%, rgba(255,255,255,1) 30%, rgba(0,0,0,1) 100%);
  position: absolute;
  top: 10%;
  left: 0;
  right: 0;
  z-index: 1;
  width: 100%;
  height: 50px;
}
.backCard .containerCvv{
  position: absolute;
  top: 35%;
  right: 0%;
  width:100%;
}
.backCard .cvv{
  background: #ffffff;
  z-index: 1;
  border-radius: 5px;
  width:85%;
  text-align:left;
}
.backCard h6{
  font-weight: bolder;
  color: #000000;
}
.backCard .line{
  width: 100%;
  height: 1px;
  background: linear-gradient(130deg, rgba(0,0,0,1) -3%, rgba(255,255,255,1) 30%, rgba(0,0,0,1) 100%);
  position: absolute;
  bottom: 5%;
  left: 0;
  right: 0;
}
.sealWorld{
  background: gray;
  background: linear-gradient(130deg, rgba(0,0,0,1) -3%, rgb(255 255 255) 30%, rgb(119 119 119) 100%);
  width: 65px;
  position: absolute;
  top: 60%;
  right: 3%;
  border-radius: 18px;
  padding: 1%;
  height: 40px;
  animation: holograma 3s ease infinite;
  background-size: 500% 500%;
}
@keyframes holograma {
  0%{
    background-position: 0 50%;
  }
  100%{
    background-position: 100% 50%;
  }
}
.seal{
  position:relative;
}
.sealWorld svg{
  width: 20px;
  height: 30px;
  position: absolute;
  filter: invert(1);
}
.sealWorld svg:nth-child(1){
  top: 0;
  right: initial;
  left: 16%;
}
.sealWorld svg:nth-child(2){
  top: 0;
  right: initial;
  left: 53%;
}
@media(max-width: 550px){
  .containerCard{
    height: 255px;
}
  .containerCard .numberCard{
    font-size: 6vw;
  }
  .containerCard .contacless{
    position: absolute;
    left: 23%;
  }
}
.cardProfile{
  min-height:250px;
}
</style>
